import { requests, mainApiRoot, regionApiRoot } from './index'

export const Region = {
  search: (searchTerm, getCountries = false) =>
    fetch(`${regionApiRoot}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ searchTerm, getCountries })
    }).then(body => body.json()),
  language: (searchEngines = []) =>
    requests.get(mainApiRoot, `/languages?by_search_engine=${searchEngines.join(',')}`)
}
